import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadContent from '../loadContent'

const fetchContent = (contentId) => HttpClient().get(`/content/v2/${contentId}`)

const getContentByIdV2 = (contentId) => (dispatch) =>
  fetchContent(contentId)
    .then((response) =>
      dispatch(loadContent(parseJSONApiResponse(response.data)))
    )
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getContentByIdV2
